import styled from 'styled-components'

import { colors } from '../../../../constants/colors'
import { FilterTitle } from '../../../projectComponents'
import { TextField } from '../../TextField'

export const SidebarTitle = styled(FilterTitle)`
  margin: 0;
  color: ${colors.black};
  font-size: 21px;
  font-weight: 700;
  line-height: 1.5;
`

export const FilterRange = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 8px;
  width: 100%;
`

export const FilterInput = styled(TextField)`
  min-width: 0;
  width: 100%;
  input {
    font-size: 14px;
    line-height: 18px;
  }
`
